"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pmParamsType2 = exports.pmParams = exports.currencyParams = exports.pmGeneralParams = exports.ProductGroup = void 0;
const types_1 = require("../types");
var ProductGroup;
(function (ProductGroup) {
    ProductGroup["LargeCap"] = "LargeCap";
    ProductGroup["MidCap"] = "MidCap";
})(ProductGroup = exports.ProductGroup || (exports.ProductGroup = {}));
exports.pmGeneralParams = {
    movesLength: 11,
    vegaTableCurrencies: [types_1.Currency.BTC, types_1.Currency.ETH],
    extendedTableShockCutOff: 100000000,
    vegaShockLV: 10000,
    volRangeUp: 0.45,
    volRangeDown: -0.3,
    initialMarginFactor: 1.2,
    atmRange: 10,
    shortTermVegaPower: 0.3,
    longTermVegaPower: 0.13,
    vegaShock: {
        vegaLevel: 10000,
        multiplier: 2,
    },
    extendedTableShock: {
        minFactor: 1.05,
        finalShockDifferenceFactor: 0.01,
    },
    skew: 0,
    curtosis: 3,
    optionInterestRate: 0,
    rollRisk: {
        minAnnualisedPercentMove: 0.01,
        annualisedPercentMoveRisk: 0.1,
    },
    largeCap: 0.6,
    midCap: 0.4,
    portfolioCap: 0.4,
    largeCapExtendedTableFactors: [
        0.15 / 0.66,
        0.15 / 0.33,
        0.3,
        0.15,
        0.075,
        0.05,
        0.15 / 4,
        0.03,
    ],
    midCapExtendedTableFactors: [
        (0.15 / 0.66) * 2,
        (0.15 / 0.33) * 2,
        0.3 * 2,
        0.15 * 2,
        0.075 * 2,
        0.05 * 2,
        (0.15 / 4) * 2,
        0.03 * 2,
    ],
};
exports.currencyParams = {
    [types_1.Currency.BTC]: {
        group: ProductGroup.LargeCap,
        moves: [-0.15, -0.12, -0.09, -0.06, -0.03, 0, 0.03, 0.06, 0.09, 0.12, 0.15],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 2800,
            factor: 0.00005,
        },
        extendedTableShock: {
            level: 100,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.ETH]: {
        group: ProductGroup.LargeCap,
        moves: [-0.15, -0.12, -0.09, -0.06, -0.03, 0, 0.03, 0.06, 0.09, 0.12, 0.15],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 35000,
            factor: 0.000004,
        },
        extendedTableShock: {
            level: 50,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.SOL]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 56000,
            factor: 0.000005,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.ADA]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 4000000,
            factor: 0.00000006,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.ALGO]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 4000000,
            factor: 0.00000006,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.AVAX]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 4000000,
            factor: 0.00000006,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.BCH]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 4000000,
            factor: 0.00000006,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.BNB]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 4000000,
            factor: 0.00000006,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.DOGE]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 4000000,
            factor: 0.00000006,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.DOT]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 280000,
            factor: 0.000001,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.LINK]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 280000,
            factor: 0.000001,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.LTC]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 280000,
            factor: 0.000001,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.MATIC]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 280000,
            factor: 0.000001,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.SHIB]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 280000,
            factor: 0.000001,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.TRX]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 280000,
            factor: 0.000001,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.UNI]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 280000,
            factor: 0.000001,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.XRP]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 6000000,
            factor: 0.000000045,
        },
        extendedTableShock: {
            level: 20,
            shockPercent: 0.01,
        },
    },
    [types_1.Currency.BTCDVOL]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 0,
            factor: 0,
        },
        extendedTableShock: {
            level: 0,
            shockPercent: 0,
        },
    },
    [types_1.Currency.ETHDVOL]: {
        group: ProductGroup.MidCap,
        moves: [-0.3, -0.24, -0.18, -0.12, -0.06, 0, 0.06, 0.12, 0.18, 0.24, 0.3],
        extendedMoves: [-0.66, -0.33, 0.5, 1, 2, 3, 4, 5],
        liquidityShock: {
            coinLimit: 0,
            factor: 0,
        },
        extendedTableShock: {
            level: 0,
            shockPercent: 0,
        },
    },
};
exports.pmParams = {
    currencyParams: exports.currencyParams,
    general: exports.pmGeneralParams,
};
exports.pmParamsType2 = {
    currencyParams: exports.currencyParams,
    general: exports.pmGeneralParams,
};
